import React from 'react';
import type {
  FormBlurEventFn,
  FormChangeEventFn,
  SetFormValueFn,
} from '@noths/polaris-client-react-hooks';
import { TextField } from '@noths/polaris-client-ribbons-design-system';

import { RadioButtonGroup } from 'src/components/molecules/RadioButtonGroup/RadioButtonGroup';
import { YES_NO_OPTIONS } from 'src/components/organisms/Signup/constants/aboutYourBusinessOptions';
import {
  DELIVER_AREAS_AREAS_COPY,
  DELIVER_AREAS_SELF_DELIVERY_COPY,
  DELIVER_AREAS_UK_COPY,
} from 'src/components/organisms/Signup/constants/copy';
import { DELIVERY_AREAS_TEST_ID } from 'src/components/organisms/Signup/constants/testIds';
import type { FormValidationErrors } from 'src/components/organisms/Signup/types';
import * as styles from 'src/styles/styles';
import type { RegistrationForm } from 'src/types/registration';

interface Props {
  clearError: (errorName: string) => void;
  errors: FormValidationErrors;
  formValues: RegistrationForm;
  onBlur: FormBlurEventFn;
  onFormChange: FormChangeEventFn;
  setFormValue: SetFormValueFn<RegistrationForm>;
}

export const DeliverAreas = ({
  clearError,
  errors,
  formValues,
  onBlur,
  onFormChange,
  setFormValue,
}: Props) => {
  return (
    <>
      <RadioButtonGroup
        accessibleLabel={DELIVER_AREAS_UK_COPY}
        additionalCss={styles.grouped}
        data-testid={DELIVERY_AREAS_TEST_ID}
        error={errors['deliverAreas.uk'] as string | undefined}
        name="deliverAreas.uk"
        onBlur={onBlur}
        onChange={(everywhereInUk) => {
          if (everywhereInUk) {
            setFormValue('deliverAreas' as keyof RegistrationForm, {
              uk: everywhereInUk,
              selfDeliveryAreas: '',
            });
            clearError('deliverAreas.uk');
            clearError('deliverAreas.selfDelivery');
            clearError('deliverAreas.selfDeliveryAreas');
          } else {
            setFormValue('deliverAreas.uk' as keyof RegistrationForm, everywhereInUk);
          }
        }}
        radioButtonData={YES_NO_OPTIONS}
        required
        value={formValues.deliverAreas.uk}
      />
      {formValues.deliverAreas.uk === false && (
        <div css={styles.easeIn}>
          <RadioButtonGroup
            accessibleLabel={DELIVER_AREAS_SELF_DELIVERY_COPY}
            additionalCss={styles.grouped}
            error={errors['deliverAreas.selfDelivery'] as string | undefined}
            name="deliverAreas.selfDelivery"
            onBlur={onBlur}
            onChange={(selfDelivery) => {
              setFormValue('deliverAreas.selfDelivery' as keyof RegistrationForm, selfDelivery);
            }}
            radioButtonData={YES_NO_OPTIONS}
            required
            value={formValues.deliverAreas.selfDelivery}
          />
          <TextField
            css={styles.textField}
            error={errors['deliverAreas.selfDeliveryAreas'] as string | undefined}
            id="business-self-delivery-areas"
            label={DELIVER_AREAS_AREAS_COPY}
            name="deliverAreas.selfDeliveryAreas"
            onBlur={onBlur}
            onChange={onFormChange}
            required
            rows={5}
            value={formValues.deliverAreas.selfDeliveryAreas}
          />
        </div>
      )}
    </>
  );
};
